<template>
  <div class="container h-100">
    <div class="page-main">
      <div class="table-search">
        <el-form class="form" size="mini" inline>
          <el-form-item label="">
            <el-input v-model="query.role_name" placeholder="请输入角色名称（支持模糊搜索）" @change="handleQuery"
                      style="width: 400px"
                      clearable></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search"
                       @click="handleQuery" :loading="loading" :disabled="loading">搜索
            </el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="default" icon="el-icon-plus" @click="addRole">新增</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="table-data">
        <div class="default-table">
          <el-table :data="roleData" @sort-change="sortChange" border
                    v-loading="loading"
                    element-loading-text="加载中"
                    element-loading-spinner="el-icon-loading"
                    @row-dblclick="handleRowEvent"


          >
            <el-table-column label="序号" type="index" align="center" width="55"></el-table-column>
            <el-table-column label="角色标识符" prop="name" align="center" sortable="custom">
              <template slot-scope="{row}">
                <el-link title="双击修改"> {{ row.name || ''}}</el-link>
              </template>
            </el-table-column>
            <el-table-column label="角色名称" prop="role_name" align="center" sortable="custom">
              <template slot-scope="{row}">
                <el-link title="双击修改"> {{ row.role_name || ''}}</el-link>
              </template>
            </el-table-column>
            <el-table-column label="备注" prop="remarks" align="center"></el-table-column>
            <el-table-column label="创建时间" prop="created_at" align="center" sortable="custom"></el-table-column>
            <el-table-column label="修改时间" prop="updated_at" align="center" sortable="custom"></el-table-column>
            <el-table-column
                key="操作项"
                label="操作项"
                align="center"
                width="160"
            >
              <template slot-scope="scope">
                <div class="buttons d-flex-row align-items-center">
                  <el-button type="text" size="mini" icon="el-icon-edit" @click="editRole(scope.row)">修改</el-button>
                  <el-button type="text" size="mini" icon="el-icon-delete"
                             v-if="['Sale','Executor','Finance','Strategy','Planner','Medium','Commerce'].indexOf(scope.row.name)===-1"
                             @click="deleteRole(scope.row)">删除
                  </el-button>
                </div>
              </template>
            </el-table-column>
          </el-table>

          <Pagination
              v-show="params.total>0"
              :total="params.total"
              :page.sync="params.page"
              :limit.sync="params.per_page"
              @pagination="handleQuery"
          />
        </div>
      </div>
    </div>


    <el-dialog :title="type==='add'?'新增':'修改'" :visible.sync="dialogRole" width="1000px"

               height="600px">
      <el-form class="billForm" :model="addRoleForm" :rules="rules" ref="addRoleForm" label-width="100px"
               style="text-align:left;padding:0 120px;" inline>
        <el-form-item label="角色名称:" prop="role_name">
          <el-input class="el-input-c" v-model="addRoleForm.role_name" placeholder="请输入角色名称"
                    maxlength="50" show-word-limit></el-input>
        </el-form-item>
        <el-form-item label="角色备注:" prop="remarks">
          <el-input class="el-input-c" v-model="addRoleForm.remarks" placeholder="请输入备注"
                    maxlength="120" show-word-limit></el-input>
        </el-form-item>
        <div class="role_box">
          <div style="padding: 10px;border: #ff3176 1px dashed;border-radius: 5px">
            <el-checkbox v-model="deptExpand" @change="handleCheckedTreeExpand($event)">展开/折叠</el-checkbox>
            <el-checkbox v-model="deptNodeAll" @change="handleCheckedTreeNodeAll($event)">全选/全不选</el-checkbox>
          </div>
          <el-tree
              ref="roleListTree"
              empty-text="加载中，请稍后..."
              :data="roleList"
              :render-after-expand="false"
              show-checkbox
              node-key="id"
              :props="{children: 'children', label: 'remarks'}"
              highlight-current
              check-on-click-node
          ></el-tree>
        </div>
        <div style="text-align: center">
          <el-button :loading="loading" :disabled="loading" type="primary" @click="roleSubmit('addRoleForm')">
            {{ type == 'add' ? '确认添加' : '保存修改' }}
          </el-button>
        </div>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import {getRoleDialogList, getRoleList, initPermissions, roleDelete, roleEditDetail, roleStore} from '@/api/role'
import Vue from 'vue'
import {Tree} from 'element-ui'

Vue.use(Tree)
export default {
  name: "role",
  components: {},
  data() {
    return {
      type: 'add',
      dialogRole: false,
      loading: false,
      roleData: [],
      query: {name: ''},
      params: {
        page: 1,
        per_page: 20,
        total: 0,
      },
      id: '',
      addRoleForm: {
        role_name: '',
        remarks: '',
        permissions: []
      },
      rules: {
        role_name: {required: true, message: '请输入角色名称', trigger: 'blur'},
        remarks: {required: true, message: '请输入角色备注', trigger: 'blur'},
      },
      roleList: [],
      roleListTree: [],
      sort: {
        order: '',
        prop: ''
      },
      doLoading: false,
      menuCheckStrictly: true,
      deptExpand: false,
      deptNodeAll: false
    }
  },
  created() {
    this.getRoleList();
  },
  methods: {
    // 树权限（展开/折叠）
    handleCheckedTreeExpand(value) {
      let permissionsList = this.roleList;
      for (let i = 0; i < permissionsList.length; i++) {
        this.$refs.roleListTree.store.nodesMap[permissionsList[i].id].expanded = value;
      }
    },
    // 树权限（全选/全不选）
    handleCheckedTreeNodeAll(value) {
      this.$refs.roleListTree.setCheckedNodes(value ? this.roleList : []);
    },

    handleQuery() {
      this.getRoleList()
    },
    getRoleList() {
      this.loading = true
      // this.roleData = [];
      getRoleList({...this.query, ...this.params, ...this.sort}).then(res => {
        this.params.total = res.model.total || 0
        this.roleData = res.model.data || [];
        this.loading = false
      })
    },
    async getRoleDialogList() {
      await getRoleDialogList().then(res => {
        this.roleList = res.model;
      })
    },

    //检测id是否是父级id，并将子级id过滤，运用递归
    checked(id, data, newArr) {
      data.forEach(item => {
        if (item.id === id) {
          if (item.children === undefined || item.children.length < 1) {
            newArr.push(item.id);
          }
        } else {
          if (item.children !== undefined && item.children.length !== 0) {
            this.checked(id, item.children, newArr)
          }
        }
      })
    },

    async addRole() {
      this.type = 'add';
      this.dialogRole = true;

      await this.getRoleDialogList();
      this.$nextTick(() => {
        this.$refs.addRoleForm.resetFields();
        this.addRoleForm = {
          role_name: '',
          remarks: '',
          permissions: []
        }
        this.$refs.roleListTree.setCheckedKeys(this.addRoleForm.permissions);
      })

    },
    // eslint-disable-next-line no-unused-vars
    handleRowEvent(row, column, event) {

      if (['role_name','name'].indexOf(column.property) > -1)
        this.editRole(row)

    },
    async editRole(val) {
      this.type = 'edit';
      this.id = val.id
      this.dialogRole = true;
      this.$nextTick(async () => {
        this.$refs.roleListTree.setCheckedKeys([]);
        await this.getRoleDialogList();

        await roleEditDetail(val.id).then(res => {
          let data = res.model || {}
          this.addRoleForm.role_name = data.role_name || '';
          this.addRoleForm.remarks = data.remarks || '';
          let permissions = data.permissions || []
          // console.log(permissions)
          let realPermissions = []
          if (permissions.length > 0) {
            permissions.forEach(item => {
              this.checked(item, this.roleList, realPermissions)
            })
          }

          // console.log(realPermissions)

          this.$refs.roleListTree.setCheckedKeys(realPermissions);

        })
      })
    },
    deleteRole(val) {
      let that = this;
      that.showModal({
        h: that,
        text: '真的要删除选中行吗？',
        confirm: function () {
          // eslint-disable-next-line
          roleDelete(val.id).then(res => {
            that.showToast({
              h: that,
              text: '删除成功！'
            });
            that.getRoleList();
          })
        },
        cancel: function () {
          // eslint-disable-next-line
          console.log('cancel')
        }
      })

    },
    sortChange(e) {
      this.sort = e
      this.handleQuery()
    },
    roleSubmit(formName) {
      this.loading = true
      let that = this;
      let addRoleForm = that.addRoleForm;
      if (that.type != 'add') {
        addRoleForm.id = that.id
      }
      // console.log(this.roleList)
      that.type == 'add' ? that.addRoleForm.type = 'store' : that.addRoleForm.type = 'update';
      // //选中的节点
      // let checkedKeys = this.$refs.roleListTree.getCheckedKeys();
      // //半选中的
      // let halfCheckedKeys = this.$refs.roleListTree.getHalfCheckedKeys();
      // that.addRoleForm.permissions = [...checkedKeys, ...halfCheckedKeys]
      that.addRoleForm.permissions = this.$refs.roleListTree.getCheckedNodes(false, true).map((i) => i.id)

      that.$refs[formName].validate((valid) => {
        if (!valid) {
          return false;
        }
        // eslint-disable-next-line
        roleStore(addRoleForm).then((res) => {
          that.dialogRole = false;
          that.showToast({
            h: that,
            text: that.type == 'add' ? '添加成功' : '编辑成功'
          });
          that.handleQuery();
          this.loading = false
        })
      });
    },

    handleInitPermissions() {
      //执行权限更新
      this.doLoading = true
      initPermissions().then(res => {
        // eslint-disable-next-line no-console
        console.log(res)
        this.msgSuccess('权限初始化任务已发布，请稍后查阅权限是否更新')

        setTimeout(() => {
          this.doLoading = false
        }, 500)
      })
    }
  }
};
</script>

<style scoped lang="scss">
.role {
  padding: 20px;
}

.header, .tableCon {
  background: #fff;
  padding: 24px 30px 0 30px;
}

.demo-table-expand {
  font-size: 0;
}

.demo-table-expand label {
  width: 90px;
  color: #99a9bf;
}

.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 50%;
}

.role_box {
  width: 100%;
  border: 1px solid #F2F6FC;
  padding: 10px;

  .el-tree {
    height: 400px;
    overflow: auto;
    margin: 0 auto;
  }

  margin-bottom: 20px;
}
</style>
<style>
.roleDialog .el-checkbox.is-bordered + .el-checkbox.is-bordered {
  margin-left: 0px !important;
}

.roleDialog .el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #E03F3D;
  border-color: #E03F3D;
}
</style>
